export interface ClusterDocument {
  document_name: string;
  chunk_count: number;
}

export interface ClusterSummary {
  cluster_id: number;
  chunk_count: number;
  documents: ClusterDocument[];
}

export interface ClustersResult {
  run_id: string | null;
  clusters: ClusterSummary[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export interface ClusterizeResult {
  run_id: string | null;
  chunk_count: number;
  cluster_count: number;
  noise_count: number;
}

export type ClusterizeJobState = 'queued' | 'running' | 'completed' | 'failed';

export type InferenceJobState = 'queued' | 'running' | 'completed' | 'failed';

export interface InferenceJobStatus {
  job_id: string;
  status: InferenceJobState;
  cluster_id: number | null;
  cluster_run_id: string | null;
  generation_id: string | null;
  result_count: number | null;
  error: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// Pipeline stages a background run passes through, in order. Fixed list of 5 - the
// progress bar divides itself into this many segments.
export type ClusterizeStage = 'fetching' | 'embedding' | 'clustering' | 'persisting' | 'relations';

export const CLUSTERIZE_STAGES: ClusterizeStage[] = ['fetching', 'embedding', 'clustering', 'persisting', 'relations'];

// Shape of both the 202 response from POST Clusterize and every poll of
// GET Clusterize/{jobId}. Only status/result/error/stage/progress change as the run progresses.
export interface ClusterizeJobStatus {
  job_id: string;
  status: ClusterizeJobState;
  min_cluster_size: number | null;
  result: ClusterizeResult | null;
  error: string | null;
  created_at: string | null;
  updated_at: string | null;
  // Null for jobs that predate progress tracking and for synchronous (background:false)
  // runs - nothing polls those. progress_total === 0 means the stage has no natural
  // count yet (indeterminate); progress_current === progress_total means that stage
  // just finished. See CLUSTERIZE_STAGES for the fixed stage order.
  stage: ClusterizeStage | null;
  progress_current: number | null;
  progress_total: number | null;
}

export interface ClusterChunk {
  chunk_id: string;
  text_content: string;
}

export interface ClusterDocumentChunksResult {
  run_id: string | null;
  cluster_id: number;
  document_name: string;
  chunks: ClusterChunk[];
}

export const CLUSTERS_PAGE_SIZE = 20;
